import React from 'react';
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import Element from "@whalecloud/page-builder-core/components/Render/components/Element";
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";

const left = css({ textAlign: 'left' });
const Collapse = props => {
  const { element, nameSpace, ...restProps } = props;
  const { data, elements } = element;
  const { componentSettings, settings, formSettings, className = '' } = data;
  const { width, horizontalAlign = 'left' } = settings;
  const { bordered = true, showArrow = true } = componentSettings || {};
  const wrapStyle: any = { width: width?.value, minHeight: 30 };
  if (bordered) {
    wrapStyle.borderBottom = '1px solid #e0e0e0';
  }
  let title;

  elements.map(v => {
    if (v.type === 'text') {
      title = v.data.text;
    }
  });

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-collapse', left)}
            {...formSettings}
          >
            {
              elements.map(element => {
                return (
                  <Element key={element.id} showArrow={showArrow} bordered={bordered} element={element} nameSpace={nameSpace} {...restProps} className={className} />
                )
              })
            }
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default Collapse;
